import { ASYNC_SUCCESS } from '../actions'

const projects = (state = null, { type, payload }) => {
  switch (type) {
    case ASYNC_SUCCESS:
      switch (payload.actionName) {
        case 'fetchProjects': {
          return { ...payload.projects }
        }

        case 'createProject': {
          return {
            ...state,
            ...payload.project
          }
        }

        case 'editProjectGeneral': {
          const { projectId, fields } = payload

          return {
            ...state,
            [projectId]: {
              ...state[projectId],
              ...fields
            }
          }
        }

        case 'editProjectUsers': {
          const { projectId, users: { roles } } = payload

          return {
            ...state,
            [projectId]: {
              ...state[projectId],
              roles
            }
          }
        }

        case 'editProjectQuestions': {
          const { projectId, questions } = payload

          return {
            ...state,
            [projectId]: {
              ...state[projectId],
              questions
            }
          }
        }

        case 'addUser': {
          const newState = { ...state }

          payload.postData.projects.forEach(project => {
            newState[project.projectId].roles[payload.userId] = project.role
          })

          return {
            ...newState
          }
        }

        case 'hubspotVerifyConnection': {
          const { projectId, response } = payload

          return {
            ...state,
            [projectId]: {
              ...state[projectId],
              usedIntegrations: {
                ...state[projectId].usedIntegrations,
                hubspot: response.status === 200
              }
            }
          }
        }

        case 'hubspotDisconnectIntegration': {
          const { projectId } = payload

          return {
            ...state,
            [projectId]: {
              ...state[projectId],
              usedIntegrations: {
                ...state[projectId].usedIntegrations,
                hubspot: false
              }
            }
          }
        }

        case 'hubspotGetAcessToken': {
          const { projectId } = payload

          return {
            ...state,
            [projectId]: {
              ...state[projectId],
              usedIntegrations: {
                ...state[projectId].usedIntegrations,
                hubspot: true
              }
            }
          }
        }

        default:
          return state
      }

    default:
      return state
  }
}

export default projects



// WEBPACK FOOTER //
// ./src/reducers/projects.js